import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Descriptions,
  Flex,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from 'antd';
import IntlMessage from '../../components/IntlMessage';
import Status from '../../components/Status';
import useTime from '../../hooks/useTime';
import dayjs from 'dayjs';
import { capitalizeFirstLetter, formatCurrency } from '../../helpers/helpers';
import busOrdersApi from '../../api/bus_orders';
import 'dayjs/locale/fr';
const { Text } = Typography;

const ModalInfoBooking = (props) => {
  const { open, onClose, item } = props;
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  console.log('check item: ', item);
  const sendSmSTicket = async (record) => {
    try {
      const res = await busOrdersApi.sendSmsTicket({
        booking_id: item.id,
        passenger_ids: [record.id],
      });
      if (res) {
        console.log('Send ticket response:', res);
        message.success('Send ticket Successfully');
      }
    } catch (err) {
      console.error(err);
    }
  };
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.firstname && record.lastname
          ? `${record.firstname}  ${record.lastname}`
          : '';
      },
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
    },
    {
      title: 'Siège',
      dataIndex: 'seat',
    },
    {
      title: 'Passeport',
      dataIndex: 'passport',
    },
    // {
    //   title: '',
    //   dataIndex: '',
    //   render: (_, record) => {
    //     return (
    //       item.order_status === 'confirmed' &&
    //       item.pay_status === 'paid' && (
    //         <Button
    //           type="primary"
    //           onClick={() => sendSmSTicket(record)}
    //           size="small">
    //           SMS
    //         </Button>
    //       )
    //     );
    //   },
    // },
  ];
  const desItems = [
    {
      key: '1',
      label: <IntlMessage id="global.reference" />,
      children: item?.order_no,
    },
    {
      key: '2',
      label: <IntlMessage id="global.total" />,
      children: formatCurrency(item?.total),
    },
    {
      key: '3',
      label: <IntlMessage id="global.sell_by" />,
      children: (
        <>
          <Space direction="vertical" size={'small'}>
            <Text>
              {convertToAnyTimezone(item?.created_at).format(
                'DD/MM/YYYY HH:mm'
              )}
            </Text>
            <Text>{item?.created_by?.fullname}</Text>
          </Space>
        </>
      ),
    },
    {
      key: '4',
      label: <IntlMessage id="global.pay_status" />,
      children: <Status status={item?.pay_status?.toLowerCase()} type="pay" />,
    },
    {
      key: '6',
      label: <IntlMessage id="global.method" />,
      children: capitalizeFirstLetter(item?.pay_method || ''),
    },
    {
      key: '5',
      label: <IntlMessage id="global.order_status" />,
      children: (
        <Status status={item?.order_status?.toLowerCase()} type="order" />
      ),
    },
    {
      key: '7',
      label: <IntlMessage id="global.from" />,
      children: <Space>{item?.route?.start_location?.title}</Space>,
    },
    {
      key: '8',
      label: <IntlMessage id="global.to" />,
      children: <Space>{item?.route?.end_location?.title}</Space>,
      span: 2,
    },
    {
      key: '9',
      label: <IntlMessage id="global.travel" />,
      children: (
        <Space size={2} direction="vertical">
          <Text>
            {/* {dayjs(
              dayjs(item?.start)
                .utc()
                .hour(item?.route?.start_time?.split(':')[0])
                .minute(item?.route?.start_time?.split(':')[1])
                .second(item?.route?.start_time?.split(':')[2])
                .toISOString()
            ).format('DD/MM/YYYY HH:mm:ss')} */}
            <Text>
              {dayjs(item?.date).locale('fr').format('dddd D MMMM YYYY')}
            </Text>
            <Text>
              {' '}
              {dayjs(item?.order_items?.[0]?.segment?.start_time, 'HH:mm:ss')
                .locale('fr')
                .format('HH:mm')}
            </Text>
          </Text>
        </Space>
      ),
      span: 3,
    },

    {
      key: '13',
      label: <IntlMessage id="global.passengers" />,
      children: (
        <>
          {item?.passengers ? (
            <Table
              columns={columns}
              dataSource={item?.passengers}
              bordered
              pagination={{
                total: item?.passengers.length,
                pageSize: 5,
              }}
            />
          ) : null}
        </>
      ),
      span: 4,
    },
    {
      key: '14',
      label: <IntlMessage id="global.notes" />,
      children: item?.notes,
      span: 3,
    },
  ];

  return (
    <Modal
      title={<IntlMessage id="global.booking_info" />}
      open={open}
      onCancel={onClose}
      width={'90%'}
      footer={[
        <Button key={'ok'} type="primary" onClick={onClose}>
          <IntlMessage id="global.ok" />
        </Button>,
      ]}>
      <Descriptions bordered items={desItems}></Descriptions>
    </Modal>
  );
};

ModalInfoBooking.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default ModalInfoBooking;
